/* eslint-disable max-len */
import {Box, Grid, Typography} from '@material-ui/core';
import Button from 'components/button';
import Popup from 'components/popup';
import {autobind} from 'core-decorators';
import userQuery from 'graphql/queries/user.gql';
import React, {Component} from 'react';
import {graphql} from 'react-apollo';
import styles from './styles.css';

@graphql(userQuery)
@autobind
export default class RouteSingsPopup extends Component {
    state = {
        visible: true,
    };

    handleClose() {
        this.setState({visible: false});
    }

    render() {
        const {user} = this.props.data;
        const shouldRender = (
            user
            && this.state.visible
        );

        if (!shouldRender) return null;
        return (
            <Popup visible={shouldRender}>
                <Grid container spacing={2} justify='space-between' alignItems='center'>
                    <Grid item>
                        <Typography variant='h1' style={{fontWeight: 'bold'}}>
                            Información a tener en cuenta
                        </Typography>
                    </Grid>
                    <Grid>
                        <button onClick={this.handleClose} theme='white'>
                            <i className='material-icons'>close</i>
                        </button>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='h3'>
                            Queremos que puedas conseguir el mejor precio y oportunidad para la realización de su cartel rutero.
                            Te brindamos 3 opciones de proveedores de carteles de ruta que nosotros conocemos para que cada RED.IN pueda gestionar la contratación y encontrar el mejor precio.
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='h3' style={{fontWeight: 'bold'}}>
                            Proveedores recomendados
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant='h3' style={{fontWeight: 'bold'}}>STRAFFELA</Typography>
                        <Typography variant='h6'>Analía San Andrés</Typography>
                        <Typography variant='h6'>eventos@straffela.com.ar</Typography>
                        <Typography variant='h6'>3462 53-8876</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant='h3' style={{fontWeight: 'bold'}}>MEDIA STRATEGY</Typography>
                        <Typography variant='h6'>Gabriela Pavese</Typography>
                        <Typography variant='h6'>gpavese@mediastrategy.com.ar</Typography>
                        <Typography variant='h6'>11 3682-39116</Typography>

                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant='h3' style={{fontWeight: 'bold'}}>PUBLICAR SA</Typography>
                        <Typography variant='h6'>Denise Morales</Typography>
                        <Typography variant='h6'>edmorales@publicar.com.ar</Typography>
                        <Typography variant='h6'>3412 78-0255</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='h3'>No es mandatorio utilizar estos proveedores,
                            pero recomendamos que se tenga en cuenta los siguientes puntos:
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography variant='body1' >
                                    <li>
                                        <span style={{fontWeight: 'bold'}}>
                                    Opciones de medidas del cartel:
                                        </span> 12 x 4 mts. o 10 x 5 mts.
                                    </li>
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant='body1' >
                                    <li>
                                        <span style={{fontWeight: 'bold'}}>
                                            La contratación debe contemplar:
                                        </span>
                                        &nbsp;Seguro por daños y/o reposición, pago de impuestos y tasas, impresión de lona/chapa y colocación.
                                    </li>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sx={12}>
                        <Typography variant='h3'>
                            Nidera brindará el diseño del cartel en el lapso de 1 semana desde el momento en el que el RED.IN confirma el tamaño (12 x 4 mts. o 10 x 5mts.).
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='h3' style={{fontWeight: 'bold'}}>Ejemplo de cartel</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Box className={styles.box}>
                            <div className={styles.example} />
                        </Box>
                    </Grid>
                    <Grid item>
                        <Typography variant='h4' style={{fontWeight: 'bold'}}>
                            Si ya tenés tu presupuesto y querés generar el reintegro de la acción, cargá el pedido!
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Button onClick={this.handleClose} fullWidth theme='yellow' className={styles.button}>
                           Continuar
                        </Button>
                    </Grid>
                </Grid>
            </Popup>
        );
    }
}



// WEBPACK FOOTER //
// ./components/route-signs-popup/index.js